import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import NsContent from 'components/common/ns-content/NsContent';

export const emailCaptureHeaderTestId = 'emailCaptureHeaderTestId';

export const EmailCaptureHeader = () => {
  return (
    <NsContent data-testid={emailCaptureHeaderTestId}>
      <NsBackCta />
      <h1>Choose a tariff at a time that suits you</h1>
      <h5>...and we’ll instantly send it to your inbox</h5>
    </NsContent>
  );
};

export default EmailCaptureHeader;